import { render, staticRenderFns } from "./AdminPageUsers.vue?vue&type=template&id=4d06552a"
import script from "./AdminPageUsers.vue?vue&type=script&lang=js"
export * from "./AdminPageUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports